import * as angular from "angular";
import {IController} from "angular";
import {TaskModel} from "../../models/task.model";

export class taskPackagesPrintItemCtrl implements IController {

  index: any;
  task: TaskModel;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskPackagesPrintItem', {
    bindings: {
      index: '<',
      task: '<'
    },
    template: require('./task-packages-print-item.html').default,
    controller: taskPackagesPrintItemCtrl
  });
